import { IdentProviderModel } from './ident-provider.model';
import { JsonObject } from '@/lib/helpers';

export class MagiclinkIdentProviderModel extends IdentProviderModel {
  constructor(props: JsonObject = {}) {
    super(props);

    this.name = 'Magic Link';
    this.type = 'magicLink';
    this.typeLabel = 'Magic Link';
    this.icon = 'magic-link';
    this.canAdd = false;
  }
}
